import * as React from "react";
// import { pure } from 'recompose';
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import * as i18next from "i18next";
// import * as cx from "classnames";
import Stream from "@tunnel-components/@sharded/widgets/stream/component";
// import * as i18next from 'i18next';
/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { arrayOfIncident, Elem, onActive, onDownloadLapiPdf } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <StyledComponent.ModalContainer
      isVisible={Elem && arrayOfIncident}
      style={{ backgroundColor: "transparent" }}
    >
      <div style={{ height: "auto" }}>
        {/** box incident simulation */}
        <StyledComponent.BoxSnapshotContainer
          className="boxSnapshot"
          isVisible={!!Elem && arrayOfIncident}
          style={{
            height: "auto",
            minHeight: "100px",
            width: "380px",
            top: "50%",
            left: "50%",
            transform: "translateY(-50%)",
          }}
        >
          <div className="vcart-incidents">
            <div className="cart-incident">
              <div className="image-snapshot-explore">
                <div className="close-box-snapshot" onClick={onActive}>
                  <span className="la-croix" />
                </div>
                <div
                  className="fakeincident-explore"
                  style={{ background: "none", height: "200px" }}
                >
                  <Stream
                    localUrl={Elem && Elem.contextImageUrl}
                    classnames="imageStream"
                  />
                </div>
                <div
                  className="fakeincident-explore"
                  style={{ background: "none", height: "200px" }}
                >
                  <Stream
                    localUrl={Elem && Elem.imageUrl}
                    classnames="imageStream"
                  />
                </div>
                <div className="extract-pdf-video" onClick={onDownloadLapiPdf}>
                  <span className="pdfVideoIcon">
                    {i18next.t("extraire le pdf")}{" "}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </StyledComponent.BoxSnapshotContainer>
        {/** box incident */}
      </div>
    </StyledComponent.ModalContainer>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  Elem?: any;
  arrayOfIncident?: any;
  onActive?: any;
  actionloading?: any;
  onExtractImpact?: any;
  onExtractVideo?: any;
  onDownloadLapiPdf?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/modal/lapi/component.tsx